import { AlertProps, ButtonProps } from "shared/components/Spor";

export const SemanticsList = [
  "alarm",
  "secondaryAlarm",
  "warning",
  "info",
  "success",
  "neutral",
  "system",
  "transparent",
  "transparentInverted",
] as const;

export type Semantics = (typeof SemanticsList)[number];

export type AlertVariant =
  | "error"
  | "error-secondary"
  | "important"
  | "success"
  | "info"
  | "neutral";

export type ButtonVariant = ButtonProps["variant"];

const SEMANTICS_TO_ALERT_VARIANT: Record<Semantics, AlertVariant> = {
  alarm: "error",
  secondaryAlarm: "error-secondary",
  warning: "important",
  info: "info",
  success: "success",
  neutral: "neutral",
  system: "info",
  transparent: "info",
  transparentInverted: "info",
};

export const semanticsToVariant = (semantics: Semantics): AlertVariant =>
  SEMANTICS_TO_ALERT_VARIANT[semantics];

export const variantToSemantics = (
  variant: AlertVariant | AlertProps["variant"] | "alt" | "service",
): Semantics | undefined => {
  switch (variant) {
    case "error":
      return "alarm";
    case "error-secondary":
      return "secondaryAlarm";
    case "important":
      return "warning";
    case "success":
    case "info":
    case "neutral":
      return variant;
    case "alt":
    case "service":
    case undefined:
    default:
      return undefined;
  }
};

export const semanticsToVariantRecord: Record<Semantics, AlertVariant> =
  SEMANTICS_TO_ALERT_VARIANT;
